import { render, staticRenderFns } from "./ServiceRightIndex.vue?vue&type=template&id=70a7e88a&scoped=true"
import script from "./ServiceRightIndex.vue?vue&type=script&lang=js"
export * from "./ServiceRightIndex.vue?vue&type=script&lang=js"
import style0 from "./ServiceRightIndex.vue?vue&type=style&index=0&id=70a7e88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7e88a",
  null
  
)

export default component.exports